import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';

import {Observable, of} from 'rxjs';
import { concatMap, switchMap, withLatestFrom, catchError, combineLatest, map, mergeMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ProActionTypes, ProActions } from '../actions/pro.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {ProService} from '../../../services/pro.service';


@Injectable()
export class ProEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private proService = inject(ProService);

  constructor() {}

  CalculateProNodes$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ProActionTypes.CalculateProNodes),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddMgtAttribute
      };
      const param = { otp: user.otp };
      return this.proService.CalculateProUpgradeNode(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.CalculateProNodesSuccess(res.msg.body.Nodes), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Add Attribute Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Attribute Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error.error.errmsg.body })];
        })
      );
    })
  ));
  $CheckProUpgrade = createEffect(() =>  this.actions$.pipe(
    ofType(featureActions.ProActionTypes.CheckProUpgrade),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.CheckProUpgrade
      };
      const param = { otp: user.otp };
      return this.proService.CheckProUpgrade(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction(updateRes)];
        })
      );
    })
  ));
  $ActivateProUpgrade = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ProActionTypes.ActivateProUpgrade),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ActivateProUpgrade
      };
      const param = { ...action.payload, otp: user.otp };
      return this.proService.ActivateProUpgrade(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return of(new featureActions.ActivateProUpgradeSuccess(res.msg.body.Nodes),
             new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true }));
          } else {
            return of(new featureActions.ActivateProUpgradeFailure(res.msg.body.Nodes));
          }
        }),
        catchError((error) => {
          return of(new featureActions.ActivateProUpgradeFailure(error));
        })
      );
    })
  ));
  $GetProNodesBank = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ProActionTypes.GetProNodesBank),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = { ...action.payload, otp: user.otp };
      return this.proService.ReadProNodes(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.GetProNodesBankSuccess(res.msg.body)];
          } else {
            return [new featureActions.GetProNodesBankFailure(res.msg.body)];
          }
        }),
        catchError((error) => {
          return [new featureActions.GetProNodesBankFailure(error)];
        })
      );
    })
  ));
  $SendProUpgradeMail = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ProActionTypes.SendProUpgradeMail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.SendProUpgradeMail
      };
      const params = {
        otp: user.otp,
        RegionId: action.payload.RegionId
      };
      return this.proService.SendProUpgradeMail(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.GetRegions(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          return of(new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Error' }));
        })
      );
    })
  ));
  $SendProPaymentDocumentMail = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ProActionTypes.SendProPaymentDocumentMail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.SendProPaymentDocumentMail
      };
      const params = {
        otp: user.otp,
        DocId: action.payload.DocId
      };
      return this.proService.SendProPaymentDocumentMail(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true })];
          } else {
            return [new featureActions.UpdateInfoFailAction(res)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          return of(new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error.error.errmsg.body }));
        })
      );
    })
  ));
  $TransferProNodes = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ProActionTypes.TransferProNodes),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = { ...action.payload, otp: user.otp };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.TransferProNodes
      };
      return this.proService.TransferProNodes(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: 'Transfer Pro Nodes Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Transfer Pro Nodes Fail', errmsg: res.errmsg.body })];
          }
        }),
        catchError((error) => {
          return [];
        })
      );
    })
  ));
  $AddProPaymentPay = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ProActionTypes.AddProPaymentPay),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = { ...action.payload, otp: user.otp };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddProPaymentPay
      };
      return this.proService.AddProPaymentPay(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true })];
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction(updateRes)];
        })
      );
    })
  ));
  $ActivatePayPalAgreement = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ProActionTypes.ActivatePayPalAgreement),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = { ...action.payload, otp: user.otp };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ActivateProUpgrade
      };
      return this.proService.ActivatePayPalAgreement(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return of(new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true }));
          } else {
            return of(new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body }));
          }
        }),
        catchError((error) => {
          return of(new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Error' }));
        })
      );
    })
  ));

}
